import { Omit } from 'bold-ui'
import { DEFAULT_SELECT_SIZE, SelectField, SelectFieldProps } from 'components/form'
import { useAsyncQuerySelect } from 'components/form/field/select/useAsyncQuerySelect'
import { ProcedimentoSelectFieldDocument } from 'graphql/hooks.generated'
import {
  GrupoProcedimentoEnum,
  ProcedimentoSelectFieldQuery,
  ProcedimentoSelectFieldQueryVariables,
  SexoEnum,
  TipoExameEnum,
  TipoProcedimentoEnum,
} from 'graphql/types.generated'
import React from 'react'

import { ProcedimentoSelectFieldItem } from './ProcedimentoSelectFieldItem'

export type ProcedimentoSelectModel = ProcedimentoSelectFieldQuery['procedimentos']['content'][0]

export interface ProcedimentoSelectFieldProps
  extends Omit<SelectFieldProps<ProcedimentoSelectModel>, 'items' | 'itemToString'> {
  tipoExame?: TipoExameEnum
  tipoProcedimento?: TipoProcedimentoEnum
  gruposProcedimento?: GrupoProcedimentoEnum[]
  filtroPadrao?: boolean
  sexo?: SexoEnum
  dataNascimento?: LocalDate
  cbo?: string
  filtrarProcedimentosOdonto?: boolean
}

export function ProcedimentoSelectField(props: ProcedimentoSelectFieldProps) {
  const {
    tipoExame,
    tipoProcedimento,
    gruposProcedimento,
    filtroPadrao,
    sexo,
    dataNascimento,
    cbo,
    filtrarProcedimentosOdonto,
    ...rest
  } = props

  const asyncProps = useAsyncQuerySelect<
    ProcedimentoSelectModel,
    ProcedimentoSelectFieldQuery,
    ProcedimentoSelectFieldQueryVariables
  >({
    query: ProcedimentoSelectFieldDocument,
    extractItems: (data) => data?.procedimentos?.content,
    variables: (inputString) => ({
      input: {
        query: inputString,
        pageParams: {
          size: DEFAULT_SELECT_SIZE,
        },
        filtro: {
          tipoExame,
          tipoProcedimento,
          gruposProcedimento,
          filtroPadrao,
          sexo,
          dataNascimento,
          cbo,
          filtrarProcedimentosOdonto,
        },
      },
    }),
  })

  const itemToString = (item: ProcedimentoSelectModel) => item?.procedimentoReferencia?.descricao || item?.descricao

  return (
    <SelectField<ProcedimentoSelectModel>
      itemToString={itemToString}
      renderItem={ProcedimentoSelectFieldItem}
      {...asyncProps}
      {...rest}
    />
  )
}
